import { pricingConditionsSlice } from "./pricingConditionsSlice";
import * as defaultActions from "../../../../../redux/_common";
import { Dispatch } from "redux";
import { get } from "../../../../../api/requester";
import { constructInitialFilters } from "../../../../components/common/filters/utils";
import { getErrorMessage } from "../../../../../redux/_helpers";
import * as fields from "../../page/PricingConditions/edit/constants";

const { actions } = pricingConditionsSlice;
const moduleUrl = "/api/pricing/pricingConditions";

export const setValidationErrors = actions.setValidationErrors;

const ID_FIELDS = [
  fields.CALCULATION_TYPE_ID,
  fields.CONDITION_TYPE_ID,
  fields.COUNTRY_ID,
  fields.CUSTOMER_TYPE_ID,
  fields.DISTRIBUTION_TYPE_ID,
  fields.DIVISION_ID,
  fields.CUSTOMER_ID,
  fields.ARTICLE_CATEGORY_ID,
  fields.ARTICLE_BRAND_ID,
  fields.ARTICLE_ID,
];

const refineDataForEdit = (data: any) => {
  if (!data) return data;

  const normalized = { ...data };

  ID_FIELDS.forEach(field => {
    if (normalized[field] === null) {
      normalized[field] = "";
    }
  });

  return normalized;
};

const refineDataForSaving = (data: any) => {
  const payload = { ...data };

  ID_FIELDS.forEach(field => {
    if (payload[field] === "") {
      payload[field] = null;
    }
  });

  return payload;
};

export const getItems = (params: {}) =>
  defaultActions.getItems(moduleUrl, actions, params);

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions, refineDataForEdit);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
    moduleUrl,
    actions,
    item,
    id,
    refineDataForSaving
  );

export const getFilters = () => async (dispatch: Dispatch) => {
  try {
    const conditionTypeFilters: any[] = await get(`${moduleUrl}/conditionType/complexSearch`);
    const countryFilters: any[] = await get(`${moduleUrl}/country/complexSearch`);
    const customerTypeFilters: any[] = await get(`${moduleUrl}/customerType/complexSearch`);
    const distributionTypeFilters: any[] = await get(`${moduleUrl}/distributionType/complexSearch`);
    const divisionFilters: any[] = await get(`${moduleUrl}/division/complexSearch`);
    const articleCategoryFilters: any[] = await get(`${moduleUrl}/articleCategory/complexSearch`);
    const articleBrandFilters: any[] = await get(`${moduleUrl}/articleBrand/complexSearch`);

    dispatch(actions.setFilter(
        constructInitialFilters([
          ...(conditionTypeFilters || []),
          ...(countryFilters || []),
          ...(customerTypeFilters || []),
          ...(distributionTypeFilters || []),
          ...(divisionFilters || []),
          ...(articleCategoryFilters || []),
          ...(articleBrandFilters || []),
        ])
      ));

    } catch (errors) {
        const message = getErrorMessage(errors, "Error occurred!");
        dispatch(actions.catchError({ message, callType: "parametersLoading", errorProp: "errorParameter" }));
    }
};

export const setFilter = (filters: any[]) => defaultActions.setFilters(filters, actions);

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
